// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  height: 100%;
  overflow: hidden;
}
body {
  height: 100vh;
  overflow-x: hidden;
}
#app-root {
  height: 100%;
}
.root-layout {
  min-height: 100%;
}
.ant-layout.page-layout {
  position: relative;
  overflow-x: auto;
  overflow-y: visible;
}
.ant-layout-content.page-content {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-header.page-header {
  background: transparent;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 80px;
}
.ant-layout-header.page-header > .ant-row {
  width: 100%;
}
.page-header,
.page-content,
.app-footer {
  min-width: 400px;
}
.page-drawer {
  top: 64px;
  height: calc(100vh - 64px);
}
.ant-layout-content.page-content {
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-content.app-content {
  flex-shrink: 0;
}
.ant-breadcrumb-link > a > .anticon + span {
  margin-left: 4px;
}
.ant-list {
  margin: 24px -24px -24px -24px;
  border-top: 1px solid rgba(230, 230, 230);
  background: white;
}
.ant-list .results-list-item {
  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.ant-list .results-list-item:hover {
  cursor: pointer;
  background: #f0f2f5;
}
.ant-list .results-list-item > .ant-row {
  flex-flow: row;
  width: 100%;
}
.ant-list .results-icon {
  height: 60px;
  width: 60px;
  margin: 0 4px 0 12px;
}
.ant-list .results-item-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.ant-list .results-item-title {
  display: flex;
  font-weight: bold;
  font-size: 16px;
  margin: 0;
}
.ant-list .results-item-timestamp {
  opacity: 0.6;
  display: inline-block;
  margin-left: auto;
  padding-right: 24px;
  font-weight: normal;
  font-size: 14px;
}
.ant-list .results-item-description {
  margin: 4px 0 0 0;
}
.ant-list .results-item-description + .results-item-description {
  margin-top: 16px;
}
.ant-list .results-item-label {
  display: inline-block;
  font-weight: bold;
  opacity: 0.6;
  margin-right: 4px;
}
.ant-list .results-item-value {
  display: inline-block;
  margin-right: 16px;
}
.ant-list .ant-list-pagination {
  margin: 0;
  padding: 24px 0;
  align-self: center;
  display: flex;
  justify-content: center;
}
.ant-list .ant-list-pagination .ant-pagination-item,
.ant-list .ant-list-pagination .ant-pagination-item-link {
  border: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/.pnpm/@nackle+studio-tools@1.9.9_@types+react@18.3.12_antd@5.24.6_date-fns@2.30.0_moment@2.30.1_rea_phmwef3nwavhog6egt6kd254om/node_modules/@nackle/studio-tools/dist/studio-tools.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;AACF;AACA;EACE,aAAA;EACA,kBAAA;AACF;AACA;EACE,YAAA;AACF;AACA;EACE,gBAAA;AACF;AACA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;AACA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AACF;AACA;EACE,wBAAA;AACF;AACA;EACE,uBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AACF;AACA;EACE,WAAA;AACF;AACA;;;EAGE,gBAAA;AACF;AACA;EACE,SAAA;EACA,0BAAA;AACF;AACA;EACE,cAAA;AACF;AACA;EACE,wBAAA;AACF;AACA;EACE,cAAA;AACF;AACA;EACE,gBAAA;AACF;AACA;EACE,8BAAA;EACA,yCAAA;EACA,iBAAA;AACF;AACA;EACE,2DAAA;AACF;AACA;EACE,eAAA;EACA,mBAAA;AACF;AACA;EACE,cAAA;EACA,WAAA;AACF;AACA;EACE,YAAA;EACA,WAAA;EACA,oBAAA;AACF;AACA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AACF;AACA;EACE,aAAA;EACA,iBAAA;EACA,eAAA;EACA,SAAA;AACF;AACA;EACE,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AACF;AACA;EACE,iBAAA;AACF;AACA;EACE,gBAAA;AACF;AACA;EACE,qBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;AACF;AACA;EACE,qBAAA;EACA,kBAAA;AACF;AACA;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AACF;AACA;;EAEE,YAAA;AACF","sourcesContent":["html {\n  height: 100%;\n  overflow: hidden;\n}\nbody {\n  height: 100vh;\n  overflow-x: hidden;\n}\n#app-root {\n  height: 100%;\n}\n.root-layout {\n  min-height: 100%;\n}\n.ant-layout.page-layout {\n  position: relative;\n  overflow-x: auto;\n  overflow-y: visible;\n}\n.ant-layout-content.page-content {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n.ant-layout-content.page-content .ant-table-wrapper {\n  margin: 0 24px 24px 24px;\n}\n.ant-layout-header.page-header {\n  background: transparent;\n  padding: 0 24px;\n  display: flex;\n  align-items: center;\n  height: 80px;\n}\n.ant-layout-header.page-header > .ant-row {\n  width: 100%;\n}\n.page-header,\n.page-content,\n.app-footer {\n  min-width: 400px;\n}\n.page-drawer {\n  top: 64px;\n  height: calc(100vh - 64px);\n}\n.ant-layout-content.page-content {\n  flex-shrink: 0;\n}\n.ant-layout-content.page-content .ant-table-wrapper {\n  margin: 0 24px 24px 24px;\n}\n.ant-layout-content.app-content {\n  flex-shrink: 0;\n}\n.ant-breadcrumb-link > a > .anticon + span {\n  margin-left: 4px;\n}\n.ant-list {\n  margin: 24px -24px -24px -24px;\n  border-top: 1px solid rgba(230, 230, 230);\n  background: white;\n}\n.ant-list .results-list-item {\n  transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.ant-list .results-list-item:hover {\n  cursor: pointer;\n  background: #f0f2f5;\n}\n.ant-list .results-list-item > .ant-row {\n  flex-flow: row;\n  width: 100%;\n}\n.ant-list .results-icon {\n  height: 60px;\n  width: 60px;\n  margin: 0 4px 0 12px;\n}\n.ant-list .results-item-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n}\n.ant-list .results-item-title {\n  display: flex;\n  font-weight: bold;\n  font-size: 16px;\n  margin: 0;\n}\n.ant-list .results-item-timestamp {\n  opacity: 0.6;\n  display: inline-block;\n  margin-left: auto;\n  padding-right: 24px;\n  font-weight: normal;\n  font-size: 14px;\n}\n.ant-list .results-item-description {\n  margin: 4px 0 0 0;\n}\n.ant-list .results-item-description + .results-item-description {\n  margin-top: 16px;\n}\n.ant-list .results-item-label {\n  display: inline-block;\n  font-weight: bold;\n  opacity: 0.6;\n  margin-right: 4px;\n}\n.ant-list .results-item-value {\n  display: inline-block;\n  margin-right: 16px;\n}\n.ant-list .ant-list-pagination {\n  margin: 0;\n  padding: 24px 0;\n  align-self: center;\n  display: flex;\n  justify-content: center;\n}\n.ant-list .ant-list-pagination .ant-pagination-item,\n.ant-list .ant-list-pagination .ant-pagination-item-link {\n  border: none;\n}\n\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
